import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d903b2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 'en' }, "English", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 'ja' }, "日本語", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 'kana' }, "にほんご", -1))
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]

import { ref } from "vue";
import { AbstractTranslation } from "../../lang/AbstractTranslation";


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelect',
  setup(__props) {

const selectedLanguage = ref(AbstractTranslation.language);
// console.log('::', selectedLanguage.value);
const to_lng = () => {
  // console.log(':?:', selectedLanguage.value);

  AbstractTranslation.language = selectedLanguage.value;
  location.reload();
};

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLanguage).value = $event)),
    class: "mx-3 px-3 form-control w zindex-dropdown",
    onChange: to_lng
  }, _hoisted_4, 544)), [
    [_vModelSelect, selectedLanguage.value]
  ])
}
}

})